import { Badge, type BadgeProps } from '@lean-agility/design-system/react';

const STATUS_MAP: Record<string, { variant: BadgeProps['variant']; label: string }> = {
  valid: { variant: 'success', label: 'Licensed' },
  expiring_soon: { variant: 'warning', label: 'Expiring soon' },
  expired: { variant: 'danger', label: 'Expired' },
  none: { variant: 'default', label: 'No license' },
  invalid: { variant: 'danger', label: 'Invalid license' },
  revoked: { variant: 'danger', label: 'License revoked' },
  wrong_deployment: { variant: 'danger', label: 'Wrong deployment' },
};

interface LicenseBadgeProps {
  status: string;
  className?: string;
}

export function LicenseBadge({ status, className }: LicenseBadgeProps) {
  const config = STATUS_MAP[status] ?? { variant: 'default' as const, label: status };
  return (
    <Badge variant={config.variant} className={className} data-testid="license-badge">
      {config.label}
    </Badge>
  );
}
